import { Statistic } from 'entities/ContactStatistic/model/Statistic'
import type { IResponseClickToTextStatistic } from 'entities/ClickToText/api/type'

export class ClickToTextStatistics extends Statistic {
  constructor({ clicks, leads }: IResponseClickToTextStatistic) {
    const total_count = clicks
    const conversions_count = leads

    super({
      total_count,
      conversions_count,
    })
  }
}
